import * as React from "react";
const SvgFiRrFaceTongueMoney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-tongue-money_svg__a)">
      <path
        fill="#062147"
        d="M24 12.039c0 6.617-5.383 12-12 12s-12-5.384-12-12q0-.55.049-1.089a1 1 0 0 1 1.992.178q-.04.45-.041.911c0 5.514 4.486 10 10 10s10-4.486 10-10q0-.462-.041-.911a1 1 0 0 1 1.992-.178q.048.538.049 1.089m-8.807-4.788 3.286.548a.625.625 0 0 1-.103 1.24h-2.644c-.356 0-.688-.192-.867-.501a1 1 0 0 0-1.731 1.003 3.01 3.01 0 0 0 2.598 1.499H16a1 1 0 0 0 2 0h.376A2.627 2.627 0 0 0 21 8.416a2.614 2.614 0 0 0-2.192-2.588l-3.286-.548a.625.625 0 0 1 .104-1.24h2.644c.356 0 .688.192.866.5a.999.999 0 1 0 1.731-1.001 3.01 3.01 0 0 0-2.598-1.499h-.268a1 1 0 0 0-2 0h-.375a2.63 2.63 0 0 0-2.625 2.624c0 1.288.922 2.377 2.193 2.588zm-10 0 3.286.548a.625.625 0 0 1-.103 1.24H5.732c-.356 0-.688-.192-.867-.501a1 1 0 0 0-1.731 1.003 3.01 3.01 0 0 0 2.598 1.499H6a1 1 0 0 0 2 0h.376A2.627 2.627 0 0 0 11 8.416a2.614 2.614 0 0 0-2.192-2.588L5.522 5.28a.625.625 0 0 1 .104-1.24H8.27c.356 0 .688.192.866.5a.999.999 0 1 0 1.731-1.001A3.01 3.01 0 0 0 8.269 2.04h-.268a1 1 0 0 0-2 0h-.375a2.63 2.63 0 0 0-2.625 2.624c0 1.288.922 2.377 2.193 2.588zM9 16.639v-.6H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2h-2v.6c0 1.635-1.147 3.4-3 3.4s-3-1.765-3-3.4m4-.6h-2v.6c0 .662.411 1.4 1 1.4s1-.738 1-1.4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-tongue-money_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceTongueMoney;
